import { useSelector } from "react-redux";
import { FlagApplicationNames, IFeatureFlagWithBVT, IUseBvtFlagsCheckerProps } from "./bvt-flags";
import { ApplicationsFlags, ISubscriptionsClientState} from "@telstra-connect/subscriptions/state";
import { mobilityAppName } from "../data/platform-data";
import useCustomerTypeCidn from "@hooks/useCustomerCidn";


const isBVTCustomer = (isTestCustomer: string[], userCidn: string) => {
    return isTestCustomer?.length && userCidn && isTestCustomer.includes(userCidn) ? true : false;
}

const isValidBvtFlag = (bvtFlag: IFeatureFlagWithBVT) => {
    if (!bvtFlag || typeof bvtFlag !== "object") return false;
    return (
        typeof bvtFlag.flagState === "boolean" &&
        typeof bvtFlag.bvtEnabledFeature === "boolean"
    );
};

function isFeatureEnabled(bvtFlag: IFeatureFlagWithBVT,
  userCidn: string, isTestCustomer: string[]): boolean {
   if (!isValidBvtFlag(bvtFlag)) return false;
   const {bvtEnabledFeature, flagState} = bvtFlag;
   if (bvtEnabledFeature && flagState) {
       return isBVTCustomer(isTestCustomer, userCidn);
   }
   return flagState;
}

const findBvtFlagFromApplicationConfig = (
    applicationConfig: ApplicationsFlags,
    appName: string,
    bvtFlagName: string
): IFeatureFlagWithBVT => {
    const appBasedFlags = applicationConfig?.[appName];
    if (!appBasedFlags) return;
    if (appBasedFlags[bvtFlagName]) {
        return appBasedFlags[bvtFlagName];
    }
    return;
};

const useBvtFlagsChecker = ({ bvtFlagName, cidn, appName }: IUseBvtFlagsCheckerProps) => {

    const applicationConfig = useSelector((state: ISubscriptionsClientState) => state.subscriptions?.applicationConfig?.data?.applications);
    const { userCidn } = useCustomerTypeCidn();
    const application: FlagApplicationNames = appName ?? mobilityAppName;
    const bvtFlag: IFeatureFlagWithBVT = findBvtFlagFromApplicationConfig(applicationConfig, application, bvtFlagName);
    const isTestCustomer: string[] = applicationConfig?.Platform?.isTestCustomer;
    const selectedCidn: string = cidn ?? userCidn;
    return {
        isBvtFlagEnabled: isFeatureEnabled(bvtFlag, selectedCidn, isTestCustomer)
    }
}

export { useBvtFlagsChecker, isFeatureEnabled }


